import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

interface Props extends React.HTMLProps<HTMLInputElement> {
  label: string;
}

const Checkbox: React.FC<Props> = ({ label, className, onChange, checked }) => (
  <label className={cn(styles.root, className)}>
    <input
      className={styles.checkbox}
      type="checkbox"
      checked={checked}
      onChange={onChange}
    />
    <span className={styles.label}>{label}</span>
  </label>
);

export default Checkbox;
